import React from 'react'
import Hidden from 'material-ui/Hidden';
import Drawer from 'material-ui/Drawer';
import { withStyles } from 'material-ui/styles'
import GileadeDrawerContent from './GileadeDrawerContent'

const drawerWidth = 240
const styles = theme => ({
  root: {
    height: '100%',
    display: 'flex'
  },
  drawerPaper: {
    width: 250,
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      position: 'relative',
      height: '100%'
    },
  },
})

function GileadeDrawer({classes, theme, toggleDrawer, isMobileOpen}) {
  return (
    <div className={classes.root}>
      <Hidden mdUp>
        <Drawer
          type="temporary"
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={isMobileOpen}
          classes={{
            paper: classes.drawerPaper,
          }}
          onRequestClose={toggleDrawer}
          ModalProps={{ keepMounted: true }} >
          <GileadeDrawerContent
            onBackPress={toggleDrawer} />
        </Drawer>
      </Hidden>
      <Hidden  smDown >
        <Drawer
          variant="permanent"
          open
          classes={{
            paper: classes.drawerPaper,
          }} >
          <GileadeDrawerContent
            onBackPress={toggleDrawer}
            classes={classes}
            theme={theme}/>
        </Drawer>
      </Hidden>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(GileadeDrawer)



// WEBPACK FOOTER //
// ./src/Components/GileadeDrawer.js